import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './api/apiSlice';
import sessionReducer from './slices/sessionSlice';
import selectionReducer from './slices/selectionSlice';

export const store = configureStore({
  reducer: {
    session: sessionReducer,
    selection: selectionReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
